import { ModalControls } from "../../../../customHooks/useModalControl";
import {
  formatToCurrency,
  getOffsetFromPage,
  getPageFromOffset,
} from "../../../../helperFunctions";
import {
  CooperativeWithdrawalApprovalQuery,
  CooperativeWithdrawalApprovalsResponse,
  SingleCooperativeWithdrawal,
} from "../../../../redux/features/approvals/approvals.type";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TimeText } from "../../../typography/timeText";
import { TableComponent } from "../../table";

export const SingleCooperativeWithdrawalTable = ({
  modalControls,
  setSelectedIds,
  selectedIds,
  approvals,
  setActionDetails,
  setSelectedEntry,
  fetching,
  query,
  setQuery,
}: {
  modalControls: ModalControls;
  selectedIds: number[];
  setSelectedIds: (v: number[]) => void;
  approvals?: CooperativeWithdrawalApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedEntry: (v: SingleCooperativeWithdrawal) => void;
  fetching: boolean;
  query: CooperativeWithdrawalApprovalQuery;
  setQuery: (v: CooperativeWithdrawalApprovalQuery) => void;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <TableComponent
      mobileCardView
      headers={["Amount", "Initiated By", "Initiated On"]}
      headerActionProps={{
        hasActions: true,
        hasCheckbox: true,
        checked:
          selectedIds.length > 0 &&
          selectedIds.length === approvals?.data?.results?.length,
        onCheck: () => {
          setSelectedIds(approvals?.data?.results?.map((i) => i.id) ?? []);
        },
        onUncheck: () => {
          setSelectedIds([]);
        },
        hasMoreMenu: true,
      }}
      rows={
        approvals?.data?.results?.map((entry, idx) => {
          return {
            id: entry.id,
            onClick: () => {
              if (selectedIds.includes(entry.id)) {
                setSelectedIds(selectedIds.filter((i) => i !== entry.id));
              } else {
                setSelectedIds([...selectedIds, entry.id]);
              }
            },
            items: [
              formatToCurrency(entry?.Amount, {
                decimalPlaces: 2,
                currency: "NGN",
              }),
              entry?.AddedByWho
                ? `${entry?.AddedByWho?.User?.FirstName} ${entry?.AddedByWho?.User?.LastName}`
                : "N/A",
              <TimeText timeString={entry?.DateAdded} showTime />,
            ],
            actionProps: {
              hasActions: true,
              hasCheckbox: true,
              checked: selectedIds.includes(entry.id),
              onCheck: () => {},
              onUncheck: () => {},
              hasMoreMenu: true,
              moreOptions: [
                {
                  icon: "verified-icon",
                  text: "Accept",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: true,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
                {
                  icon: "close-icon",
                  text: "Decline",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: false,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
              ],
            },
          };
        }) ?? []
      }
      stickyLastCol
      isRowClickable={true}
      onRowClick={() => {}}
      isTableEmpty={[0, undefined].includes(approvals?.data?.results?.length)}
      emptyTitle="No Pending Approvals"
      isLoading={fetching}
      isPaginated
      currentPage={getPageFromOffset(query.offset!, query.limit!)}
      totalCount={approvals?.data?.count}
      itemsPerPage={query.limit}
      onPageChange={(page) => {
        setQuery({
          ...query,
          offset: getOffsetFromPage(page, query.limit!),
        });
        setSelectedIds([]);
      }}
    />
  );
};
